import React from 'react';

import { SvgIcon } from 'components/icons/SvgIcon';

type Props = {
  children: React.ReactNode;
  title: string;
  icon?: string;
  iconStyle?: React.CSSProperties;
};

export const SellingPoint: React.FC<Props> = (props) => (
  <div>
    {props.icon && (
      <SvgIcon
        icon={props.icon}
        style={{
          fontSize: '32px',
          height: '32px',
          marginBottom: '4px',
          maxWidth: '32px',
          ...props.iconStyle,
        }}
      />
    )}
    <h3 className='mb-1 lh-1'>{props.title}</h3>
    <div className='standfirst standfirst--subtle fw-300'>{props.children}</div>
  </div>
);
